import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=b2f769f6&lang=pug&"
import script from "./tabs.vue?vue&type=script&lang=js&"
export * from "./tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/serg/my/projects/pub.settv.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2f769f6')) {
      api.createRecord('b2f769f6', component.options)
    } else {
      api.reload('b2f769f6', component.options)
    }
    module.hot.accept("./tabs.vue?vue&type=template&id=b2f769f6&lang=pug&", function () {
      api.rerender('b2f769f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/tabs.vue"
export default component.exports